<script setup>
import i18n from "@/i18n";

const {t, te} = i18n.global;

const props = defineProps({
  label: {
    type: String,
    required: true
  }
});
</script>

<template>
  <div v-if="te(props.label)" class="float-end">
    <i class="bi bi-question text-primary" :title="t(props.label)"/>
  </div>
</template>